const isCombined = $(`#variant-options[data-type="Combined"]`).length > 0;
let _allVariants;
Object.defineProperty(window, 'allVariants', {
    get() { return _allVariants; },
    set(val) { _allVariants = val; }
});
if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  let pageInit = true;
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this._colorSwatchRepaired = false;
      if (pageInit) {
        this.mainProductFetch();
        pageInit = false;
      }
      // For Combined products with a variant URL, kick off the color swatch repair
      // immediately in parallel with mainProductFetch (no need to wait for GraphQL).
      this._earlyRepairColorSwatches();
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.addEventListener("change", this.onVariantChange);
      
      // Initialize variant selection handlers
      this.initializeVariantHandlers();
      
      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
      this.updateProductVariant = this.updateProductVariant.bind(this);
      this.updateMedia();
      const activeSlides = document.querySelectorAll('.product-images__slide.is-active');
      const initialSlides = document.querySelectorAll('.product-images__slide.is-initial-selected');
      const checkedColor = document.querySelector('.product-form__input--color input:checked');
      const colorLabel = document.querySelector('.product-form__input--color .form__label__value');
    
      setTimeout(() => {
        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        const hiddenVariantInput = document.getElementById('selected-variant-id');
        const hiddenVariantId = hiddenVariantInput?.value;
        // Prefer Liquid-resolved variant (smallest in-stock / same-color smallest) over a stale ?variant= id
        const preferredId = hiddenVariantId || urlVariantId;
        if (
          this.updateUrl &&
          hiddenVariantId &&
          urlVariantId &&
          String(hiddenVariantId) !== String(urlVariantId)
        ) {
          try {
            const u = new URL(window.location.href);
            u.searchParams.set('variant', hiddenVariantId);
            window.history.replaceState({}, '', `${u.pathname}${u.search}${u.hash}`);
          } catch (_) { /* noop */ }
        }
        
        this.updateOptions();
        this.updateMasterId();
        
        this.updateDescription();
        
        let variantToUse = null;
        if (preferredId) {
          const variantData = this.getVariantData();
          variantToUse = variantData?.find(v => String(v.id) === String(preferredId));
        }
        if (!variantToUse?.sku) variantToUse = this.currentVariant;
        
        const skuEl = document.querySelector('.product-sku span.sku-value');
        if (skuEl && variantToUse?.sku) {
          skuEl.textContent = variantToUse.sku;
        }
        
        const colorFieldset = this.querySelector('.product-form__input--color');
        if (colorFieldset) {
          const checkedRadio = colorFieldset.querySelector('input[type="radio"]:checked');
          const label = colorFieldset.querySelector('.form__label__value');
          if (checkedRadio && label && label.textContent !== checkedRadio.value) {
            label.textContent = checkedRadio.value;
          }
        }
    }, 1000);

      
    }
    connectedCallback() {
      this.setDisabled();
    }

    async _earlyRepairColorSwatches() {
      if (document.getElementById('variant-options')?.dataset.type !== 'Combined') return;
      if (!new URLSearchParams(window.location.search).get('variant')) return;

      try {
        const sections = await this.fetchProductSections(this.dataset.url);
        if (!sections?.colorFieldsetHTML) return;

        const colorFieldset = this.querySelector('.product-form__input--color');
        if (!colorFieldset) return;

        const domColorCount = colorFieldset.querySelectorAll('input[name="Color"]').length;
        const newColorCount = (sections.colorFieldsetHTML.match(/name="Color"/g) || []).length;
        if (newColorCount <= domColorCount) return;

        const checkedColor = colorFieldset.querySelector('input[name="Color"]:checked')?.value;
        colorFieldset.outerHTML = sections.colorFieldsetHTML;

        const newColorFieldset = this.querySelector('.product-form__input--color');
        if (newColorFieldset) {
          newColorFieldset.querySelectorAll('input[name="Color"]').forEach(r => {
            r.checked = (r.value === checkedColor);
          });
          const labelEl = newColorFieldset.querySelector('.form__label__value');
          if (labelEl && checkedColor) labelEl.textContent = checkedColor;
        }
        this._colorSwatchRepaired = true;
      } catch (e) {
        console.error('[earlyRepairColorSwatches] Failed:', e);
      }
    }

    initializeVariantHandlers() {
      // Handle size label clicks
      $(window).on('click', '.varient-selection-size-label', this.handleSizeLabelClick.bind(this));

      // Handle dropdown changes
      const select = document.getElementById("option-select-2");
      if (select) {
        select.addEventListener("change", (event) => this.updateSelectedVariant(event.target));
      }
    }

    handleSizeLabelClick(event) {
      const target = event.target;
      if (!target.classList.contains("varient-selection-size-label")) return;

      const fieldset = target.closest("fieldset");
      if (!fieldset) return;

      const dataHandle = fieldset.getAttribute("data-handle");
      const spanValue = target.getAttribute("data-value");
      const cookieName = `selected_prod_${dataHandle}`;
      
      // Update cookie
      setTimeout(() => {
        this.deleteCookie(cookieName);
        this.setCookie(cookieName, spanValue, 1);
      }, 1000);

      // Update variant selection
      const hiddenInput = document.getElementById("selected-variant-id");
      const dataId = target.getAttribute("data-id");
      if (hiddenInput && dataId) {
        hiddenInput.value = dataId;
        hiddenInput.dispatchEvent(new Event("change"));
      }
    }

    updateSelectedVariant(selectElement) {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const dataId = selectedOption.getAttribute("data-id");
      const sku = selectedOption.getAttribute("data-sku");

      const hiddenInput = document.getElementById("selected-variant-id");
      if (hiddenInput && dataId) {
        hiddenInput.value = dataId;
        hiddenInput.dispatchEvent(new Event("change"));
      }

      // Update SKU display
      const skuElement = document.querySelector(".product-sku span.sku-value");
      if (skuElement && sku) {
        skuElement.innerHTML = sku;
      }
    }

    onVariantChange(event) {
      const isColor = event.target.name === 'Color';

      this.variantId = event.target.dataset.id;
      this.url = event.target.dataset.url;

      if (isColor) {
        window.history.replaceState({}, '', this.url);
        const variantData = this.getVariantData();
        const matchedVariant = variantData?.find(v => String(v.id) === String(this.variantId));
        if (matchedVariant?.sku) {
          const skuEl = document.querySelector('.product-sku span.sku-value');
          if (skuEl) skuEl.textContent = matchedVariant.sku;
        }
        if (matchedVariant?.price !== undefined) {
          this._applyPriceFromVariant(matchedVariant);
        }
        this.updateProductVariant(event, isColor);
      }

      this.updateOptions();
      this.updateMasterId();

      // Immediately update SKU and size label for size changes
      if (!isColor && this.currentVariant) {
        const skuEl = document.querySelector('.product-sku span.sku-value');
        if (skuEl && this.currentVariant.sku) skuEl.textContent = this.currentVariant.sku;
        const sizeLabelEl = document.querySelector(
          '.product-form__input[data-handle="size"] .form__label__value, .product-form__input[data-index="option2"] .form__label__value'
        );
        if (sizeLabelEl && this.currentVariant.option2) sizeLabelEl.textContent = this.currentVariant.option2;
      }

      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      
      if (!this.currentVariant) {
        this.toggleAddButton(true, window.theme?.variantStrings?.soldOut || 'Out of Stock', true);
      } else {
        const variations = document.querySelector('.variations');
        if (!variations.classList.contains('loaded')) {
          variations.classList.add('loaded');
        }
        if (!isColor) {
          this.renderProductInfo(isColor, this.currentVariant?.id);
        }
      }

      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });

      // Only call setDisabled for non-color changes.
      // For color changes, replaceProductSections handles it after DOM rebuild.
      if (!isColor) {
        this.setDisabled(isColor);
      }
    }
    updateDescription() {
      const descriptionEl = document.querySelector('.collapsible__content[data-desc]');
      if (!descriptionEl) return;
      const originalDesc = descriptionEl.dataset?.desc;
      const variantDesc = descMap[this.currentVariant?.id];
      const newDesc = variantDesc || originalDesc || '';
      if (newDesc !== descriptionEl.innerHTML) {
        descriptionEl.innerHTML = newDesc;
      }
    }

    updateProductVariant(event, isColor) {
      const radioTarget = event.target;
      if (!radioTarget) return;
    
      document.querySelectorAll(".varient-selection-label, .varient-selection-size-label").forEach(rb => {
        rb.checked = false;
      });
    
      let productUrl = radioTarget.getAttribute("data-url");
    
      if (productUrl) {
        this.fetchProductSections(productUrl).then(sections => {
          return this.replaceProductSections(sections, isColor);
        }).catch(error => console.error("Error updating product sections:", error));
      }
    }

    async fetchProductSections(productUrl) {
      try {
        const separator = productUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${productUrl}${separator}view=sections-template`);
        const html = await response.text();
        // Use DOMParser instead of innerHTML to avoid triggering custom element
        // constructors (e.g. VariantSelects) which would cause an infinite fetch loop.
        const tempDoc = new DOMParser().parseFromString(html, 'text/html');
    
        const priceInner = tempDoc.querySelector(".product-information .product-price-container .price");
        const priceOuter = tempDoc.querySelector('[id^="price-"]');
    
        return {
          titleSection: tempDoc.querySelector(".product-title")?.innerHTML,
          variantsSectionContents: Array.from(tempDoc.querySelectorAll(".sizes-block")).map(section => section.innerHTML),
          variantsDataContents: tempDoc.querySelector('[data-variants][type="application/json"]')?.innerHTML,
          cartFormSection: tempDoc.querySelector(".product-add-to-cart-form")?.innerHTML,
          pricesection: priceInner?.innerHTML,     
          priceOuterHTML: priceOuter?.innerHTML,      
          priceSectionId: priceOuter?.id,            
          style: tempDoc.querySelector(".product-sku")?.innerHTML,
          mediasection: this.getMediaSection(tempDoc),
          colorFieldsetHTML: tempDoc.querySelector('.product-form__input--color')?.outerHTML,
        };
      } catch (error) {
        console.error("[fetchProductSections] Error:", error);
        throw error;
      }
    }

    /**
     * Combined PDP often SSRs band/cup from the parent or wrong child; option.values may omit cups.
     * Hydrate .sizes-block from the active color row's product URL (same as clicking that swatch).
     */
    async refreshSizesBlocksForActiveColor() {
      if (document.getElementById('variant-options')?.getAttribute('data-type') !== 'Combined') return;
      const colorInput = this.querySelector('.product-form__input--color input[type="radio"]:checked');
      const productUrl = colorInput?.getAttribute('data-url');
      if (!productUrl) return;
      try {
        const sections = await this.fetchProductSections(productUrl);
        if (!sections?.variantsSectionContents?.length) return;
        const containers = document.querySelectorAll('.sizes-block');
        containers.forEach((container, index) => {
          if (sections.variantsSectionContents[index]) {
            container.innerHTML = sections.variantsSectionContents[index];
          }
        });
        mergeMissingCupRadiosFromGraphql();
        _formatSizesOrder.delete('cup');
        _formatSizesOrder.delete('band');
        await formatSizes();
        initializeRadioButtons();
      } catch (e) {
        console.error('[refreshSizesBlocksForActiveColor]', e);
      }
    }

    updateVariantUrl() {
      const checkedInput = document.querySelector('fieldset.product-form__input input[type="radio"]:checked');
      const checkedUrl = checkedInput.getAttribute("data-url");
      window.history.replaceState({}, "", `${checkedUrl}`);
    }
    getMediaSection(tempDiv) {
      if (document.querySelector(".product-gallery-container")) {
        return tempDiv.querySelector(".product-image-container")?.innerHTML;
      }
      return tempDiv.querySelector(".small-12.large-7.columns")?.innerHTML;
    }

    async replaceProductSections(sections, isColor) {
      if (!sections) return;

      this.updateProductSections(sections);
      this.handleCookiesOnLoad();
      if (isColor) {
        await updateVariants();
      }
      if (document.getElementById('variant-options')?.getAttribute('data-type') === 'Combined') {
        mergeMissingCupRadiosFromGraphql();
      }
      formatSizes();
      initializeRadioButtons();
      this.updateOptions();
      this.updateMasterId();
      this.updateDescription();

      if (this.currentVariant) {
        const skuEl = document.querySelector('.product-sku span.sku-value');
        if (skuEl && this.currentVariant.sku) skuEl.textContent = this.currentVariant.sku;
        const hid = document.getElementById('selected-variant-id');
        if (hid) hid.value = this.currentVariant.id;
      }

      if (isCombined) {
        const oosBadge = document.querySelector('.product-price-container .badge.out-of-stock');
        if (oosBadge && this.currentVariant?.available) {
          oosBadge.remove();
        }
      }

      if (isColor) {
        this.updateVariantInput();
        await this.updateMedia();
      }

      this.setDisabledSync(isColor);
      this.updateButtonState();
    }

  updateProductSections(sections) {
    const elements = {
      title:    document.querySelector(".product-title"),
      variants: document.querySelectorAll(".sizes-block"),
      cartForm: document.querySelector(".product-add-to-cart-form"),
      price:    document.querySelector(".product-information .product-price-container .price"),
      sku:      document.querySelector(".product-sku"),
    };
  
    if (elements.title)    elements.title.innerHTML    = sections.titleSection;
    if (elements.cartForm) elements.cartForm.innerHTML = sections.cartFormSection;
    if (elements.sku)      elements.sku.innerHTML      = sections.style;
  
    if (elements.price && sections.pricesection) {
      elements.price.innerHTML = sections.pricesection;
    }
  
    if (sections.priceSectionId && sections.priceOuterHTML) {
      const priceWrapper = document.getElementById(sections.priceSectionId);
      if (priceWrapper) {
        priceWrapper.innerHTML = sections.priceOuterHTML;
        priceWrapper.classList.remove('visibility-hidden');
      }
    } else {
      const fallbackWrapper = document.getElementById(`price-${this.dataset.section}`);
      if (fallbackWrapper && sections.pricesection) {
        fallbackWrapper.classList.remove('visibility-hidden');
      }
    }
  
    if (!isCombined) {
      const variantsData = document.querySelector('variant-selects script[type="application/json"]');
      if (variantsData) variantsData.innerHTML = sections.variantsDataContents;
    }
  
    elements.variants?.forEach((container, index) => {
      if (sections.variantsSectionContents[index]) {
        container.innerHTML = sections.variantsSectionContents[index];
      }
    });
  }
  

    async updateMediaSections(sections) {
      const mediaContainer = document.querySelector(".product-gallery-container") || 
                            document.querySelector(".product-gallery-sticky");
      
      if (mediaContainer && sections.mediasection) {
        mediaContainer.innerHTML = sections.mediasection;
        
        // Hide zoom element if present
        const mediaZoomElement = document.querySelector(".product-single__media-zoom");
        if (mediaZoomElement) {
          mediaZoomElement.style.display = "none";
        }
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            this.options.push(checkedRadio.value);
          } else if (fieldset.dataset.handle === 'color' || fieldset.dataset.index === 'option1') {
            this.options.push(fieldset.querySelector(".form__label__value").textContent);
          } else {
            this.options.push(fieldset.querySelector(".form__label__value").textContent);
          }
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let labelValueSpan = item.querySelector(".form__label__value");
        if (labelValueSpan) {
          if (
            item.dataset.index === "option1" &&
            item.dataset.handle === "color"
          ) {
            const selectedInput = item.querySelector( 'input[type="radio"]:checked' );

            if (selectedInput) {
              const selectedLabel = item.querySelector(
                `label[for="${selectedInput.id}"]`
              );
              if (selectedLabel) {
                const colorValue =
                  selectedLabel.getAttribute("title") ||
                  selectedLabel.getAttribute("data-value");
                labelValueSpan.innerHTML = colorValue;
              }
            }
          } else {
            if (this.options[i] !== undefined) {
              labelValueSpan.innerHTML = this.options[i];
            }
          }
        }
      });
    }
    updateMasterId() {
      if (this.options) {
        const variantData = this.getVariantData();

        if (isCombined) {
          const checkedColorRadio = this.querySelector('.product-form__input--color input[type="radio"]:checked');
          const currentColor = checkedColorRadio?.value;

          if (currentColor) {
            this.currentVariant = variantData?.find((variant) => {
              return variant.option1 === currentColor &&
                     variant.options.slice(1).every((option, index) => {
                       return this.options[index + 1] === option;
                     });
            });
            return;
          }
        }

        this.currentVariant = variantData?.find((variant) => {
          return variant.options.every((option, index) => {
            return this.options[index] === option;
          });
        });
      }
    }

    async updateMedia() {
      if (!this.currentVariant || (!isCombined && !this.currentVariant.featured_media)) return;
      let thumbnails = document.querySelector('#Product-Thumbnails');
      if (this.productSlider && thumbnails) {
        if (isCombined) {
          // await this.mainProductFetch();
          const variantColor = document.querySelector('.product-form__input--color .form__label__value').textContent;
          $(`.product-thumbnail:not([data-color="${variantColor}"]), .product-images__slide:not([data-color="${variantColor}"])`)
            .removeClass('is-active')
            .prop('disabled', true);
          $(`.product-thumbnail[data-color="${variantColor}"], .product-images__slide[data-color="${variantColor}"]`)
            .addClass('is-active')
            .prop('disabled', false);
          this.setActiveMedia(
            `.product-images__slide[data-color="${variantColor}"]`,
            `.product-thumbnail[data-color="${variantColor}"]`,
            this.productSlider,
            thumbnails,
            true
          );
        } else {
          this.setActiveMedia(
            `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            this.productSlider,
            thumbnails
          );
        }
      }
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails, combined = false) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelectorAll(mediaId)[0];
      if (flkty) {
        if (this.hideVariants) {
          if (!combined) {
            if ( productSlider.querySelector( ".product-images__slide.is-initial-selected" ) ) {
              productSlider.querySelector(".product-images__slide.is-initial-selected")
                .classList.remove("is-initial-selected");
            }
            productSlider.querySelectorAll( ".product-images__slide" ).forEach(el => {
              el.classList.remove("is-active");
            });
            activeMedia.classList.add("is-active");
            activeMedia.classList.add("is-initial-selected");
          }
          this.setImageSetMedia();

          if (thumbnails) {
            let activeThumbs = thumbnails.querySelectorAll(thumbId);
            
            if ( thumbnails.querySelector(".product-thumbnail.is-initial-selected") ) {
              thumbnails
                .querySelector(".product-thumbnail.is-initial-selected")
                .classList.remove("is-initial-selected");
            }
            thumbnails.querySelectorAll(".product-images__slide").forEach(el => {
              el.classList.remove("is-active");
            });
            if (activeThumbs.length > 0) {
              activeThumbs.forEach(thumb => {
                thumb.classList.add("is-active");
              });
              activeThumbs[0].classList.add("is-initial-selected");
            }
          }
          if (productSlider?.reInit) {
            productSlider.reInit();
          }
        }
        productSlider?.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      var titleWithHyphens = this.currentVariant.title.replace(/ /g, "-");
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}/${titleWithHyphens
          .toLowerCase()
          .replace("/", "-")
          .trim()
          .replace(" ", "-")}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
    formatId(formId) {
      if (formId.includes('/')) {
        return formId.split('/').pop();
      }
      return formId;
    }
    updateVariantInput() {
      this.updateOptions();
      this.updateMasterId();
      if (this.currentVariant?.id) {
        const productForms = document.querySelectorAll( `#product-form-${this.dataset.section}, #product-form-installment` );
        productForms?.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent( new Event("change", { bubbles: true, }) );
        });
      }
      this.updateMedia();
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
      ];
    }
    renderProductInfo(isColor = false, preferredVariantId = null) {
      const selectedId = preferredVariantId
        || document.getElementById('selected-variant-id')?.value
        || this.querySelector('input[name="id"]')?.value
        || this.currentVariant?.id;
      const url = `${this.dataset.url}?variant=${selectedId}&section_id=${this.dataset.section}`;
      if (!selectedId) return;
      let sections = this.getSectionsToRender();
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);

            if (price) price.classList.remove("visibility-hidden");

            if (isCombined) {
              const oosBadge = document.querySelector('.product-price-container .badge.out-of-stock');
              if (oosBadge && this.currentVariant?.available) {
                oosBadge.remove();
              }
            }
          });
          // Use variant we actually fetched so button state and SKU match
          const variantData = this.getVariantData();
          const fetchedVariant = variantData?.find(v => String(v.id) === String(selectedId));
          if (fetchedVariant) this.currentVariant = fetchedVariant;
          const hid = document.getElementById('selected-variant-id');
          if (hid && selectedId) hid.value = selectedId;
          const skuEl = document.querySelector('.product-sku span.sku-value');
          if (skuEl && fetchedVariant?.sku) skuEl.textContent = fetchedVariant.sku;
          this.toggleAddButton(
            !this.currentVariant?.available,
            window.theme.variantStrings.soldOut
          );
          this.updateVariantInput();
          if (!this.productSlider) {
            this.productSlider = document.querySelector(".product-images");
          }
          if (this.productSlider?.reInit) {
            this.productSlider.reInit();
          }
          this.setDisabled(isColor);
          this.updateButtonState();
        });
    }

    updateButtonState() {
      // Check both the current variant AND whether any variant for this color is available
      let available = this.currentVariant?.available;
      
      if (available === undefined || available === null) {
        const variantData = this.getVariantData();
        const currentColor = this.currentVariant?.option1 
          || document.querySelector('.product-form__input--color .form__label__value')?.textContent;
        if (variantData && currentColor) {
          available = variantData.some(v => v.option1 === currentColor && v.available);
        }
      }
    
      const addButton = document.querySelector('[name="add"]');
      const addButtonText = document.querySelector('[name="add"] > span');
      if (!addButton || !addButtonText) return;
    
      if (available) {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = addButtonText.dataset.addToCart || window.theme?.variantStrings?.addToCart || 'Add to cart';
      } else {
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = addButtonText.dataset.soldOut || window.theme?.variantStrings?.soldOut || 'Out of Stock';
      }
    }
    

    _applyPriceFromVariant(variant) {
      const formatMoney = (cents) => {
        if (typeof Shopify?.formatMoney === 'function') {
          return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
        }
        return '$' + (cents / 100).toFixed(2);
      };
    
      const priceWrapper = document.getElementById(`price-${this.dataset.section}`);
      if (!priceWrapper) {
        return;
      }
    
      const regularPriceEl = priceWrapper.querySelector('.price-item--regular, .price__regular .price-item');
      const salePriceEl    = priceWrapper.querySelector('.price-item--sale, .price__sale .price-item--sale');
      const compareEl      = priceWrapper.querySelector('.price-item--regular.price--compare, .price__compare .price-item');
    
      if (regularPriceEl && !variant.compare_at_price) {
        regularPriceEl.textContent = formatMoney(variant.price);
        priceWrapper.classList.remove('price--on-sale');
      } else if (salePriceEl && variant.compare_at_price && variant.compare_at_price > variant.price) {
        salePriceEl.textContent  = formatMoney(variant.price);
        if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price);
        priceWrapper.classList.add('price--on-sale');
      }
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;
    
      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
    
      if (!addButton) return;
    
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButton.classList.remove("loading");
    
        if (productTemplate?.includes("pre-order")) {
          addButtonText.textContent = window.theme.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add("sold-out");
      if (price) price.classList.add("visibility-hidden");
    }

    setDisabled(isColor = false) {
      const delay = this.isDisabledFeature === 'true' ? 1000 : 50;
      let snapshotVariant = this.currentVariant;

      setTimeout(() => {
        this.updateOptions();
        const variant_data = this.filterVariantDataToVisible(this.getVariantData());
        if (!variant_data) return;

        let selected_options = false;

        if (snapshotVariant) {
          selected_options = snapshotVariant.options.map((value, index) => ({
            value,
            index: `option${index + 1}`
          }));
        } else {
          const currentColor = this.options[0];
          const firstAvailable = variant_data.find(
            v => v.option1 === currentColor && v.available
          );

          if (firstAvailable) {
            snapshotVariant = firstAvailable;
            if (!this.currentVariant) {
              this.currentVariant = firstAvailable;
            }
            selected_options = firstAvailable.options
              .filter(opt => opt !== null && opt !== undefined)
              .map((value, index) => ({
                value,
                index: `option${index + 1}`
              }));
          } else {
            const anyForColor = variant_data.find(v => v.option1 === currentColor);
            if (anyForColor) {
              snapshotVariant = anyForColor;
              selected_options = anyForColor.options
                .filter(opt => opt !== null && opt !== undefined)
                .map((value, index) => ({
                  value,
                  index: `option${index + 1}`
                }));
            } else {
              return;
            }
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        // If NO variant for this color is available, cross out ALL band/cup options
        const currentColor = selected_options.find(o => o.index === 'option1')?.value;
        if (currentColor) {
          const anyAvailableForColor = variant_data.some(
            v => v.option1 === currentColor && v.available
          );
          if (!anyAvailableForColor) {
            if (available_options.option2) {
              available_options.option2.forEach(opt => { opt.isUnavailable = true; });
            }
            if (available_options.option3) {
              available_options.option3.forEach(opt => { opt.isUnavailable = true; });
            }
          }
        }

        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];
          if (!fieldset_options) return;
          fieldset.querySelectorAll('input').forEach((input) => {
            const option = fieldset_options.find(opt => String(opt.value) === String(input.value));
            if (option) {
              option.isUnavailable ? input.classList.add('is-disabled') : input.classList.remove('is-disabled');
            }
          });
        });

        this.updateButtonState();
      }, delay);
      return true;
    }

    setDisabledSync(isColor = false) {
      this.updateOptions();
      const variant_data = this.filterVariantDataToVisible(this.getVariantData());
      if (!variant_data) return;

      let snapshotVariant = this.currentVariant;
      let selected_options = false;

      if (snapshotVariant) {
        selected_options = snapshotVariant.options.map((value, index) => ({
          value,
          index: `option${index + 1}`
        }));
      } else {
        const currentColor = this.options[0];
        const firstAvailable = variant_data.find(
          v => v.option1 === currentColor && v.available
        );

        if (firstAvailable) {
          snapshotVariant = firstAvailable;
          this.currentVariant = firstAvailable;
          selected_options = firstAvailable.options
            .filter(opt => opt !== null && opt !== undefined)
            .map((value, index) => ({
              value,
              index: `option${index + 1}`
            }));
        } else {
          const anyForColor = variant_data.find(v => v.option1 === currentColor);
          if (anyForColor) {
            snapshotVariant = anyForColor;
            selected_options = anyForColor.options
              .filter(opt => opt !== null && opt !== undefined)
              .map((value, index) => ({
                value,
                index: `option${index + 1}`
              }));
          } else {
            return;
          }
        }
      }

      const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

      // If NO variant for this color is available, cross out ALL band/cup options
      const currentColor = selected_options.find(o => o.index === 'option1')?.value;
      if (currentColor) {
        const anyAvailableForColor = variant_data.some(
          v => v.option1 === currentColor && v.available
        );
        if (!anyAvailableForColor) {
          if (available_options.option2) {
            available_options.option2.forEach(opt => { opt.isUnavailable = true; });
          }
          if (available_options.option3) {
            available_options.option3.forEach(opt => { opt.isUnavailable = true; });
          }
        }
      }

      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((fieldset, i) => {
        const fieldset_options = Object.values(available_options)[i];
        if (!fieldset_options) return;
        fieldset.querySelectorAll('input').forEach((input) => {
          const option = fieldset_options.find(opt => String(opt.value) === String(input.value));
          if (option) {
            option.isUnavailable ? input.classList.add('is-disabled') : input.classList.remove('is-disabled');
          }
        });
      });

      this.updateButtonState();
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;
      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex && !isCombined) {
        return;
      }
      if (this.imageSetIndex) {
        let selected_set_images, selected_set_thumbs;
        let setValue = this.getImageSetName(
          this.currentVariant[this.imageSetIndex]
        );
        let group = this.imageSetName + "_" + setValue;
        selected_set_images = this.productWrapper.querySelectorAll( `.product-images__slide[data-set-name="${this.imageSetName}"]` );
        selected_set_thumbs = this.productWrapper.querySelectorAll( `.product-thumbnail[data-set-name="${this.imageSetName}"]` );
        if (this.hideVariants) {
          // Product images
          this.productWrapper
            .querySelectorAll(".product-images__slide")
            .forEach((thumb) => {
              if (thumb.dataset.group && thumb.dataset.group !== group) {
                thumb.classList.remove("is-active");
              }
            });
          selected_set_images.forEach((thumb) => {
            thumb.classList.toggle("is-active", thumb.dataset.group === group);
          });
          // Product thumbnails
          this.productWrapper.querySelectorAll(".product-thumbnail").forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
          selected_set_thumbs.forEach((thumb) => {
            thumb.classList.toggle("is-active", thumb.dataset.group === group);
          });
        }
      }
    }

    getVisibleOptionValues() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      const visibleValues = {};
      fieldsets.forEach((fieldset, i) => {
        const optionIndex = `option${i + 1}`;
        visibleValues[optionIndex] = new Set(
          Array.from(fieldset.querySelectorAll('input[type="radio"]')).map(inp => String(inp.value))
        );
      });
      return visibleValues;
    }

    filterVariantDataToVisible(variant_data) {
      const visibleValues = this.getVisibleOptionValues();
      return variant_data.filter(variant => {
        return Object.entries(visibleValues).every(([index, values]) => {
          if (variant[index] === null || variant[index] === undefined) return true;
          return values.has(String(variant[index]));
        });
      });
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      const selectedMap = {};
      selected_options.forEach(({ value, index }) => {
        selectedMap[index] = value;
      });
    
      return variant_data.reduce(
        (options, variant) => {
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;
    
            let entry = options[index].find(
              (option) => option.value === variant[index]
            );
    
            if (typeof entry === "undefined") {
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }
    
            if (index === "option1") {
              if (variant.available) {
                entry.isUnavailable = false;
              }
            }
            else if (index === "option2") {
              // Band is "in stock" only if an available variant exists for this band
              // with the *currently selected cup* (option3). Otherwise a band can look
              // selectable while the active band+cup combo is OOS (cup shows strike, band does not).
              const cupSel = selectedMap["option3"];
              const noCupSelected =
                cupSel === undefined || cupSel === null || cupSel === "";
              if (
                variant.available &&
                variant.option1 === selectedMap["option1"] &&
                (noCupSelected || variant.option3 === cupSel)
              ) {
                entry.isUnavailable = false;
              }
            }
            else if (index === "option3") {
              if (
                variant.available &&
                variant.option1 === selectedMap["option1"] &&
                variant.option2 === selectedMap["option2"]
              ) {

                entry.isUnavailable = false;
              }
            }
          });
    
          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }
    getVariantData() {
      const fromWin = window.allVariants;
      if (Array.isArray(fromWin) && fromWin.length > 0) {
        return fromWin;
      }
      const el = document.querySelector('[data-variants]');
      if (!el?.textContent) return [];
      try {
        const parsed = JSON.parse(el.textContent);
        const list = Array.isArray(parsed) ? parsed : [];
        return list;
      } catch (_) {
        return [];
      }
    }
    async fetchProductDetails(tag) {
        try {
            const response = await fetch(`https://${Shopify.shop}/api/2025-04/graphql.json`, {
                method: "POST",
                headers: {
                    'X-Shopify-Storefront-Access-Token': window.storefrontToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: `
                      query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                          products(first: 100, query: $query) {
                              edges {
                                  node {
                                      availableForSale
                                      id
                                      title
                                      handle
                                      productType
                                      discontinued: metafield(namespace: "custom", key: "discontinued") {
                                          value
                                          type
                                      }
                                      variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                          value
                                          type
                                      }
                                      color: metafield(namespace: "shopify", key: "color-pattern") {
                                        ...MetafieldFragment
                                        value
                                        type
                                        key
                                        namespace
                                        references(first: 10) {
                                            edges {
                                              node {
                                                ... on Metaobject {
                                                  fields {
                                                    key
                                                    value
                                                  }
                                                }
                                              }
                                            }
                                          }
                                      }
                                      totalInventory
                                      priceRange {
                                          maxVariantPrice {
                                              amount
                                              currencyCode
                                          }
                                          minVariantPrice {
                                              amount
                                              currencyCode
                                          }
                                      }
                                      media(first: 25) {
                                        edges {
                                          node {
                                            ... on MediaImage {
                                              image {
                                                altText
                                                url
                                                id
                                              }
                                            }
                                            alt
                                            id
                                          }
                                        }
                                      }
                                      variants(first: 100) {
                                          edges {
                                              node {
                                                  id
                                                  sku
                                                  title
                                                  availableForSale
                                                  price {
                                                      amount
                                                      currencyCode
                                                  }
                                                  quantityAvailable
                                                  compareAtPrice {
                                                      amount
                                                      currencyCode
                                                  }
                                                  options: selectedOptions {
                                                      name
                                                      value
                                                  }
                                                  image {
                                                      src
                                                      altText
                                                      id
                                                  }
                                              }
                                          }
                                      }
                                  }
                              }
                          }
                      }
                      fragment MetafieldFragment on Metafield {
                        id
                        key
                      }
                    `,
                    variables: {
                        query: `tag:${tag} AND status:ACTIVE`,
                        country: Shopify.country
                    }
                })
            });
            const { data, errors } = await response.json();
            if (errors) {
                console.error('GraphQL Errors:', errors);
                return null;
            }
            if (data && data.products.edges) {
                const productDetails = data.products.edges
                  .map(({ node }) => {
                      if (node) {
                          return node;
                      } else {
                          console.warn("Encountered a null product.");
                          return null;
                      }
                  })
                  .filter(Boolean);
                return productDetails;
            } else {
                console.warn("No product data found.");
                return null;
            }
        } catch (error) {
            console.error("Error fetching product:", error);
            return []; // Return an empty array on error to prevent breaking subsequent code
        }
    }
    async mainProductFetch(init=false) {
        const productType = document.getElementById('variant-options').dataset.type;
        const productStyleNo = document.getElementById('product-style-num').value;
        
        let flkty = this.productSlider?.flkty;
        
        if (productType == 'Combined') {
          if (!this.productDetails) {
            this.productDetails = await this.fetchProductDetails(productStyleNo);
          }
          
          if (this.productDetails?.length > 1) {
            this.productDetails = this.productDetails.filter(childProduct => childProduct.productType != 'Combined');
            
            if (this.productDetails.length <= 1) {
              const existingSlides = document.querySelectorAll('#Product-Slider .product-images__slide');
              const existingThumbs = document.querySelectorAll('#Product-Thumbnails .product-thumbnail');
              
              existingSlides.forEach((slide, idx) => {
                slide.classList.add('is-active');
                if (idx === 0) slide.classList.add('is-initial-selected');
              });
              existingThumbs.forEach((thumb, idx) => {
                thumb.classList.add('is-active');
                if (idx === 0) thumb.classList.add('is-initial-selected');
              });
              
              document.querySelector('#variant-options').classList.add('loaded');
              return;
            }
            
            $('#Product-Thumbnails .product-thumbnail, #Product-Slider .product-images__slide').remove();
            window.allVariants = this.productDetails?.flatMap(colorVariant =>
              colorVariant.variants.edges.map(edge => edge.node)
            ).map(variant => {
              const optionValues = variant.options?.map(option => option.value) || [];
              return {
                ...variant,
                id: this.formatId(variant.id),
                options: optionValues,
                option1: optionValues[0] || null,
                option2: optionValues[1] || null,
                option3: optionValues[2] || null,
                available: typeof variant.availableForSale === 'boolean'
                  ? variant.availableForSale
                  : (variant.available !== undefined
                      ? variant.available
                      : (variant.quantityAvailable != null ? variant.quantityAvailable > 0 : false)),
                price: variant.price?.amount          // ← add
                  ? Math.round(parseFloat(variant.price.amount) * 100)
                  : undefined,
                compare_at_price: variant.compareAtPrice?.amount  // ← add
                  ? Math.round(parseFloat(variant.compareAtPrice.amount) * 100)
                  : undefined,
              }
            });

            const variantDataEl = document.querySelector('[data-variants]');
            if (variantDataEl && allVariants?.length) {
              variantDataEl.textContent = JSON.stringify(allVariants);
              this.updateMasterId();
            }
          }
          flkty = flkty || (new Flickity(this.productSlider, {
              wrapAround: true,
              pageDots: true,
              contain: true,
              initialIndex: init ? ".is-active.is-initial-selected" : ".is-initial-selected",
              adaptiveHeight: true,
              prevNextButtons: false,
              cellSelector: `.product-images__slide${init ? '.is-active' : ''}`,
          }));
          const thumbnails = document.querySelector('#Product-Thumbnails');
          // Add all variant images
          const sectionId = thumbnails.dataset.sectionId;
          const selectedColor = document.querySelector('.product-form__input--color .form__label__value').textContent;
          const processImages = (variantImages, variantColor, variantProduct) => {
            const isActive = (variantColor && selectedColor) ? variantColor.toLowerCase() === selectedColor.toLowerCase() : false;
            variantImages.forEach((image, idx) => {
              const imageId = image.id.split('/').pop();
              const isFirstOfVariant = idx == 0;
              const slide = document.createElement('div');
              const initialSelected = isActive && isFirstOfVariant;
              const slideId = `Slide-${sectionId}-${imageId}`;
              const imageUrl = image.url || image.src;
              const imageAlt = image.altText || image.alt || `${variantProduct.title} - ${variantColor}`;
              if (!$(`#${slideId}`).length) {
                slide.id = slideId;
                slide.className = `product-images__slide ${isActive ? 'is-active' : ''}${isFirstOfVariant ? ' first-of-variant' : ''}${initialSelected ? ' is-initial-selected' : ''}`;
                if (variantColor) {
                  slide.dataset.color = variantColor;
                }
                slide.dataset.variantId = variantProduct.id;
                slide.innerHTML = `
                  <div class="product-single__media product-single__media-image ${isFirstOfVariant ? 'first-of-variant' : ''}" data-color="${variantColor}">
                      <a href="${imageUrl}" class="product-single__media-zoom" data-msrc="${imageUrl}&amp;width=20" data-h="1280" data-w="853" target="_blank" tabindex="-1" aria-label="Zoom">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.24998 6.25022H8.24996M6.24997 4.25023V8.25021M9.96205 9.96248L12.9996 13M11.4999 6.24997C11.4999 9.14945 9.14945 11.4999 6.24997 11.4999C3.35049 11.4999 1 9.14945 1 6.24997C1 3.35049 3.35049 1 6.24997 1C9.14945 1 11.4999 3.35049 11.4999 6.24997Z" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>
                      </a>
                      <img class="" src="${imageUrl}" width="853" height="1280" data-sizes="auto" data-image-product-id fetchpriority="auto" sizes="578px" alt="${imageAlt}" />
                  </div>
                `;
                flkty.append(slide);
                $('#Product-Slider .flickity-slider').append(slide);
              }
              else {
                $(`#${slideId}`).addClass(isActive ? 'is-active' : '');
              }
              // Add to thumbnails
              const thumb = document.createElement('li');
              const thumbId = `Thumb-${sectionId}-${imageId}`;
              if (!$(`#${thumbId}`).length) {
                thumb.id = thumbId;
                thumb.className = `product-thumbnail ${isActive ? 'is-active' : ''}${isFirstOfVariant ? ' first-of-variant' : ''}${initialSelected ? ' is-initial-selected' : ''}`;
                thumb.innerHTML = `<img src="${imageUrl}" alt="${imageAlt}" />`;
                if (variantColor) {
                  thumb.dataset.color = variantColor;
                }
                thumbnails.appendChild(thumb);
              }
              else {
                $(`#${thumbId}`).addClass(isActive ? 'is-active' : '');
              }
            });
          }
          this.productDetails?.forEach(variantProduct => {
            // const variantVariants = variantProduct?.variants?.edges?.map(variant => variant.node);
            const variantColor = variantProduct?.color?.references.edges[0].node.fields.find(field => field.key == 'label')?.value;
            const variantImages = variantProduct.media.edges.map(img => img.node.image);
            if (variantImages.length) {
              processImages(variantImages, variantColor, variantProduct);
            }
          });
          if (flkty) {
            if (this.productSlider?.reInit) {
              this.productSlider.reInit();
            }
            else if (this.productSlider?.init) {
              this.productSlider.init();
            }
            else {
              flkty.destroy();
            }
          }
          if (!flkty) {
            flkty = this.productSlider?.flkty || (new Flickity('#Product-Slider', {
              wrapAround: true,
              pageDots: true,
              contain: true,
              initialIndex: init ? ".is-active.is-initial-selected" : ".is-initial-selected",
              adaptiveHeight: true,
              prevNextButtons: false,
              cellSelector: `.product-images__slide${init ? '.is-active' : ''}`,
            }));
          }

          // Repair color swatches if Shopify's Combined Listing served a subset
          // (happens when navigating from PLP with a variant that belongs to a smaller group)
          const colorFieldset = this.querySelector('.product-form__input--color');
          const domColorCount = colorFieldset
            ? colorFieldset.querySelectorAll('input[name="Color"]').length
            : 0;
          const fetchedColorCount = new Set(
            this.productDetails
              .map(p => p?.color?.references?.edges?.[0]?.node?.fields?.find(f => f.key === 'label')?.value)
              .filter(Boolean)
          ).size;

          if (colorFieldset && domColorCount < fetchedColorCount && !this._colorSwatchRepaired) {
            try {
              const checkedColor = colorFieldset.querySelector('input[name="Color"]:checked')?.value;
              const sections = await this.fetchProductSections(this.dataset.url);
              if (sections?.colorFieldsetHTML) {
                colorFieldset.outerHTML = sections.colorFieldsetHTML;
                const newColorFieldset = this.querySelector('.product-form__input--color');
                if (newColorFieldset) {
                  newColorFieldset.querySelectorAll('input[name="Color"]').forEach(r => {
                    r.checked = (r.value === checkedColor);
                  });
                  const labelEl = newColorFieldset.querySelector('.form__label__value');
                  if (labelEl && checkedColor) labelEl.textContent = checkedColor;
                }
              }
              this._colorSwatchRepaired = true;
            } catch (e) {
              console.error('[mainProductFetch] Color swatch repair failed:', e);
            }
          }

          try {
            await this.refreshSizesBlocksForActiveColor();
          } catch (e) {
            console.error('[mainProductFetch] refreshSizesBlocksForActiveColor:', e);
          }

          this.updateOptions();
          this.updateMasterId();

          if (this.currentVariant) {
            const skuEl = document.querySelector('.product-sku span.sku-value');
            if (skuEl && this.currentVariant.sku) {
              skuEl.textContent = this.currentVariant.sku;
            }
            const hid = document.getElementById('selected-variant-id');
            if (hid) hid.value = this.currentVariant.id;
          }

          const waitForFlickity = setInterval(() => {
            const flkty = Flickity.data(this.productSlider);
            if (flkty) {
              clearInterval(waitForFlickity);
              this.updateMedia();
            }
          }, 50);

          document.querySelector('#variant-options').classList.add('loaded');
          applySmallestAvailableDefault();
        }
    }

    handleCookiesOnLoad() {
      const self = this;
      document.querySelectorAll('.product-form__input:not([data-index="option1"])').forEach((fieldset) => {
        const dataHandle = fieldset.getAttribute("data-handle");
        const cookieName = `selected_prod_${dataHandle}`;
        const sizeCookie = this.getCookie(cookieName);
        
        if (sizeCookie) {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = input.nextElementSibling;
            if (input.value === sizeCookie) {
              const hiddenInput = document.getElementById("selected-variant-id");
              const hiddenInput1 = label.getAttribute("data-id");
              if (hiddenInput && hiddenInput1) {
                const selectedVariantId = hiddenInput1;
                // hiddenInput.value = selectedVariantId;
                // hiddenInput.dispatchEvent(new Event("change"));
              }
            }
          });
        }
      });
    }

    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    deleteCookie(name) {
      document.cookie = name + "=; Max-Age=-99999999; path=/";
    }
  }
  
  /**
   *  @class
   *  @function ProductForm
   */
  if (!customElements.get("product-form")) {
    customElements.define(
      "product-form",
      class ProductForm extends HTMLElement { 
        constructor() {
          super();
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cartNotification = document.querySelector("cart-notification");
          this.body = document.body;
  
          this.hideErrors = this.dataset.hideErrors === "true";
        }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
          if (!this.form.reportValidity()) {
            return;
          }
          const submitButton = this.querySelector('[type="submit"]');
          if (submitButton.classList.contains("loading")) return;
  
          this.handleErrorMessage();
  
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
  
          const config = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
          };
          const formData = new FormData(this.form);
          formData.append(
            "sections",
            this.getSectionsToRender().map((section) => section.section)
          );
          formData.append("sections_url", window.location.pathname);
          config.body = formData;
          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                dispatchCustomEvent("product:variant-error", {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                return;
              }
              if (response?.sections) {
                this.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
        }
  
        getSectionsToRender() {
          return [
            {
              id: "Cart",
              section: "main-cart",
              selector: ".thb-cart-form",
            },
            {
              id: "Cart-Drawer",
              section: "cart-drawer",
              selector: ".cart-drawer",
            },
            {
              id: "cart-drawer-toggle",
              section: "cart-bubble",
              selector: ".thb-item-count",
            },
          ];
        }
        renderContents(parsedState) {
          this.getSectionsToRender().forEach((section) => {
            if (!document.getElementById(section.id)) {
              return;
            }
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            if (window.cartDrawer) {
              window.cartDrawer.initEvents();
            }
            else if (typeof CartDrawer !== "undefined") {
              new CartDrawer();
            }
            if (typeof Cart !== "undefined") {
              new Cart().renderContents(parsedState);
            }
          });
  
          if (document.getElementById("Cart-Drawer")) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
            dispatchCustomEvent("cart-drawer:open");
          }
  
          let product_drawer = document.getElementById("Product-Drawer");
          if (product_drawer && product_drawer.contains(this)) {
            product_drawer.classList.remove("active");
  
            if (!document.getElementById("Cart-Drawer")) {
              this.body.classList.remove("open-cc");
            }
          }
        }
        getSectionInnerHTML(html, selector = ".shopify-section") {
          return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
        }
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            );
  
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  
    /*const fieldsets = document.querySelectorAll(
      ".variations .product-form__input--color"
    );
    fieldsets.forEach((fieldset) => {
      const firstLabel = fieldset.querySelector("label");
      if (firstLabel) {
        // firstLabel.click();
      }
    });*/
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            this.options.push(checkedRadio.value);
          } else {
            this.options.push(fieldset.querySelector(".form__label__value").textContent);
          }
        }
      });
    }
    updateVariantText() {}
  }

  customElements.define("variant-radios", VariantRadios);
}

function initializeProductSlider() {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.thumbnail_container = this.product_container.querySelector( ".product-thumbnail-container" );
      this.video_containers = this.querySelectorAll( ".product-single__media-external-video--play" );
      this.setOptions();
      // Start Slider
      if (this.flkty) {
        this.reInit();
      }
      else {
        this.init();
      }
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll(".product-thumbnail");
      }
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-active.is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
      };

      if (this.classList.contains("product-quick-images")) {
        this.options.cellAlign = "left";
        this.options.imagesLoaded = true;
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);
      this.selectCell(".product-images__slide.is-initial-selected");
      $("#Product-Slider").find(".product-images__slide").removeClass('is-selected');
      $("#Product-Slider").find(".product-images__slide.is-initial-selected").addClass('is-selected');
      
      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      if (this.flkty) {
        this.flkty.destroy();
      }

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();
      this.flkty.reloadCells();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    filterActiveCells() {
      this.flkty.cells.forEach(cell => {
        const elem = cell.element;
        if (elem.classList.contains('is-active')) {
            elem.style.display = 'block';
        } else {
          elem.style.display = 'none';
        }
      });
      this.flkty.reloadCells();
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        // _this.filterActiveCells();
        const fCells = this.flkty.cells[_this.selectedIndex];
        if (!fCells) {
          return;
        }
        let previous_slide = fCells.element,
          previous_media = previous_slide.querySelector(
            ".product-single__media"
          ),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector(".product-single__media"),
          active_thumb = false;
        if (this.thumbnail_container) {
          let active_thumbs = Array.from(_this.thumbnails).filter((element) =>
              element.classList.contains("is-active")
            ),
            active_thumb = active_thumbs[index]
              ? active_thumbs[index]
              : active_thumbs[0];
          _this.thumbnails.forEach((item, i) => {
            item.classList.remove("is-initial-selected");
          });
          active_thumb.classList.add("is-initial-selected");
          active_thumb.classList.add("is-active");
        }
        requestAnimationFrame(() => {
          if (active_thumb) {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left:
                active_thumb.offsetLeft -
                windowHalfWidth +
                active_thumb.clientWidth / 2,
              top:
                active_thumb.offsetTop -
                windowHalfHeight +
                active_thumb.clientHeight / 2,
              behavior: "smooth",
            });
          }
        });

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video"
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*"
            );
          }
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video"
          )
        ) {
          previous_media.querySelector("video").pause();
        }

        // Draggable.
        if (media.classList.contains("product-single__media-model")) {
          this.setDraggable(false);
        } else {
          this.setDraggable(true);
        }
      });

      if (this.thumbnail_container) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(
            (element) => element.clientWidth > 0
          );
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener("click", () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
        });
      }
      let scrollbar = document.querySelector(
        ".product-quick-images__scrollbar>div"
      );

      if (scrollbar) {
        this.flkty.on("scroll", function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = "scaleX(" + progress + ")";
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      this.thumbnails.forEach(function (el) {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
      this.reInit();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image"
        )
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode
        );

        let activelink = item.querySelector(".product-single__media-zoom");
        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected"
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };
      const that = this;
      this.links.forEach((link) => {
        link.addEventListener("click", (e) => that.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/** Canonical size orders (smallest → largest). Shared by formatSizes() + smallest-variant scoring. */
const NATORI_APPAREL_SIZES = Object.freeze([
  'XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL', '1X', '2X', '3X', '4XL', 'O/S',
]);
const NATORI_BANDS = Object.freeze(['26', '28', '30', '32', '34', '36', '38', '40', '42', '44']);
const NATORI_CUPS = Object.freeze([
  'A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'I', 'J',
]);

function rankInNatoriList(val, orderedList) {
  const u = String(val || '').toUpperCase().trim();
  const i = orderedList.findIndex((x) => String(x).toUpperCase() === u);
  return i >= 0 ? i : 999;
}

/**
 * Sort key for one variant option value vs a fieldset (uses data-handle + NATORI_* lists).
 */
function variantOptionRank(val, fieldset, fieldsetIndex) {
  const handle = (fieldset.getAttribute('data-handle') || '').toLowerCase();
  const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
  const u = String(val || '').toUpperCase().trim();

  if (handle === 'color' || handle === 'colour') {
    const pos = radios.findIndex((r) => String(r.value).toUpperCase() === u);
    return pos >= 0 ? pos : 999;
  }

  if (handle === 'band') {
    const ranked = rankInNatoriList(val, NATORI_BANDS);
    if (ranked < 999) return ranked;
    const n = parseInt(String(val), 10);
    if (Number.isFinite(n)) return n;
    const pos = radios.findIndex((r) => String(r.value) === String(val));
    return pos >= 0 ? pos + 5000 : 9999;
  }

  if (handle === 'cup') {
    return rankInNatoriList(val, NATORI_CUPS);
  }

  if (handle === 'size') {
    const ranked = rankInNatoriList(val, NATORI_APPAREL_SIZES);
    if (ranked < 999) return ranked;
    const pos = radios.findIndex((r) => String(r.value) === String(val));
    return pos >= 0 ? pos : 999;
  }

  // No / unknown data-handle: infer from typical bra field order (color → band → cup)
  if (fieldsetIndex === 0) {
    const pos = radios.findIndex((r) => String(r.value).toUpperCase() === u);
    return pos >= 0 ? pos : 999;
  }
  if (fieldsetIndex === 1) {
    const ranked = rankInNatoriList(val, NATORI_BANDS);
    if (ranked < 999) return ranked;
    const n = parseInt(String(val), 10);
    return Number.isFinite(n) ? n : 9999;
  }
  if (fieldsetIndex === 2) {
    return rankInNatoriList(val, NATORI_CUPS);
  }

  const pos = radios.findIndex((r) => String(r.value) === String(val));
  return pos >= 0 ? pos : 999;
}

/** Lexicographic score for pickSmallestAvailableVariantForColor (aligns with formatSizes order). */
function variantSmallestScore(variant, fieldsets) {
  const MULT = 100000;
  let score = 0;
  fieldsets.forEach((fs, idx) => {
    const val =
      idx === 0 ? variant.option1 : idx === 1 ? variant.option2 : variant.option3;
    score = score * MULT + variantOptionRank(val, fs, idx);
  });
  return score;
}

/**
 * GraphQL / combined listings can include variant options that this PDP does not render.
 * Only consider variants whose option values each match an existing radio (see filterVariantDataToVisible).
 */
function variantOptionsMatchDomRadios(variant, fieldsets) {
  const list = Array.isArray(fieldsets) ? fieldsets : Array.from(fieldsets || []);
  if (!variant || !list.length) return false;
  return list.every((fs, idx) => {
    const radios = fs.querySelectorAll('input[type="radio"]');
    if (!radios.length) return true;
    const val = idx === 0 ? variant.option1 : idx === 1 ? variant.option2 : variant.option3;
    if (val === null || val === undefined || val === '') return false;
    const s = String(val);
    return Array.from(radios).some((r) => String(r.value) === s);
  });
}

function pickSmallestAvailableVariantForColor(availableVariants, checkedColor, fieldsets) {
  const list = Array.isArray(fieldsets) ? fieldsets : Array.from(fieldsets);
  const filtered = availableVariants.filter((v) => v.option1 === checkedColor);
  const pool = filtered.filter((v) => variantOptionsMatchDomRadios(v, list));
  if (!pool.length) return null;
  return pool.reduce((best, v) =>
    variantSmallestScore(v, list) < variantSmallestScore(best, list) ? v : best
  );
}

/**
 * Keep cup radio data-id / data-url in sync with color + band (needed after GraphQL-merged extras).
 */
function syncCupRadioVariantAttrs(cupFieldset, allVariants, colorVal, bandVal) {
  if (!cupFieldset || !colorVal || bandVal == null || String(bandVal) === '') return;
  const path = window.location.pathname;
  cupFieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
    const cup = radio.value;
    const v = allVariants.find(
      (x) =>
        String(x.option1) === String(colorVal) &&
        String(x.option2) === String(bandVal) &&
        String(x.option3) === String(cup)
    );
    if (v) {
      radio.setAttribute('data-id', String(v.id));
      radio.setAttribute('data-url', `${path}?variant=${v.id}`);
    } else {
      radio.removeAttribute('data-id');
      radio.removeAttribute('data-url');
    }
  });
}

/**
 * Smallest cup that actually exists for color+band (any stock state).
 * Used only when the current cup is not a real SKU for that band — OOS combos keep the selected cup.
 */
function findSmallestExistingCupVariantForBand(allVariants, colorVal, bandVal, fieldsets) {
  const list = Array.isArray(fieldsets) ? fieldsets : Array.from(fieldsets || []);
  const pool = allVariants.filter(
    (v) =>
      String(v.option1) === String(colorVal) && String(v.option2) === String(bandVal)
  );
  if (!pool.length) return null;
  return pool.reduce((best, v) =>
    variantSmallestScore(v, list) < variantSmallestScore(best, list) ? v : best
  );
}

function dispatchVariantSelectsSyncFromCup(cupFieldset) {
  const checked = cupFieldset?.querySelector('input[type="radio"]:checked');
  if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
}

/**
 * Liquid / sections-template often only list cups tied to sparse option.values; GraphQL has the full matrix.
 * Add any missing cup radios for this color so band changes can show/hide via updateFieldsetRadios.
 */
function mergeMissingCupRadiosFromGraphql() {
  const vo = document.getElementById('variant-options');
  if (vo?.getAttribute('data-type') !== 'Combined') return;

  const vs = document.querySelector('variant-selects');
  if (!vs || typeof vs.getVariantData !== 'function') return;

  const allVariants = vs.getVariantData();
  if (!Array.isArray(allVariants) || !allVariants.length) return;

  const colorInput = vs.querySelector('.product-form__input--color input[type="radio"]:checked');
  const colorVal = colorInput?.value;
  if (!colorVal) return;

  const cupFieldset = vs.querySelector('fieldset.product-form__input[data-handle="cup"]');
  if (!cupFieldset) return;

  const templateInput = cupFieldset.querySelector('input[type="radio"]');
  if (!templateInput) return;

  const templateLabel = Array.from(cupFieldset.querySelectorAll('label')).find(
    (l) => l.getAttribute('for') === templateInput.id
  );

  const unionCups = [
    ...new Set(
      allVariants
        .filter(
          (v) =>
            String(v.option1) === String(colorVal) && v.option3 != null && String(v.option3) !== ''
        )
        .map((v) => String(v.option3))
    ),
  ].sort(
    (a, b) => rankInNatoriList(a, NATORI_CUPS) - rankInNatoriList(b, NATORI_CUPS)
  );

  const existingValues = new Set(
    Array.from(cupFieldset.querySelectorAll('input[type="radio"]')).map((r) => String(r.value))
  );

  let added = 0;
  const formId = templateInput.getAttribute('form');

  for (const cup of unionCups) {
    if (existingValues.has(cup)) continue;

    const input = templateInput.cloneNode(true);
    const label = templateLabel ? templateLabel.cloneNode(true) : null;
    const uid = `natori-merged-cup-${added}-${Date.now().toString(36)}`;

    input.id = uid;
    input.value = cup;
    input.checked = false;
    input.removeAttribute('checked');
    input.classList.remove('is_selected', 'is-disabled');
    input.removeAttribute('data-id');
    input.removeAttribute('data-url');
    if (formId) input.setAttribute('form', formId);

    if (label) {
      label.setAttribute('for', uid);
      label.textContent = cup;
      label.classList.remove('is_selected', 'is-disabled');
    }

    cupFieldset.appendChild(input);
    if (label) cupFieldset.appendChild(label);
    existingValues.add(cup);
    added++;
  }

  if (added > 0) {
    _formatSizesOrder.delete('cup');
    const bandEl = vs.querySelector('fieldset[data-handle="band"] input[type="radio"]:checked');
    if (bandEl) syncCupRadioVariantAttrs(cupFieldset, allVariants, colorVal, bandEl.value);
  }
}

/**
 * Snap UI to smallest in-stock variant using NATORI_* order + variantSmallestScore.
 * With ?variant=: keep that variant's color (option1), smallest band/cup for that color.
 * (Replaces the old variant-lexical-score.liquid SSR loop.)
 */
function applySmallestAvailableDefault() {
  const vs = document.querySelector('variant-selects');
  if (!vs || typeof vs.getVariantData !== 'function') return;

  const allVariants = vs.getVariantData();
  if (!Array.isArray(allVariants) || !allVariants.length) return;

  const available = allVariants.filter((v) => v.available);
  if (!available.length) return;

  const fieldsets = [
    ...document.querySelectorAll('variant-selects .variations fieldset.product-form__input'),
  ];
  if (!fieldsets.length) return;

  const urlId = new URLSearchParams(window.location.search).get('variant');
  let baseColor = null;
  if (urlId) {
    const urlV = allVariants.find((v) => String(v.id) === String(urlId));
    if (urlV?.option1) baseColor = urlV.option1;
  }
  const checkedColorInput = fieldsets[0]?.querySelector('input[type="radio"]:checked');
  if (!baseColor && checkedColorInput) baseColor = checkedColorInput.value;

  const poolByColor = baseColor
    ? available.filter((v) => v.option1 === baseColor)
    : available;
  if (!poolByColor.length) return;

  const pool = poolByColor.filter((v) => variantOptionsMatchDomRadios(v, fieldsets));
  if (!pool.length) return;

  let best = pool[0];
  let bestScore = variantSmallestScore(best, fieldsets);
  for (let i = 1; i < pool.length; i++) {
    const s = variantSmallestScore(pool[i], fieldsets);
    if (s < bestScore) {
      best = pool[i];
      bestScore = s;
    }
  }

  fieldsets.forEach((fs, idx) => {
    const val = idx === 0 ? best.option1 : idx === 1 ? best.option2 : best.option3;
    if (val == null || val === '') return;
    const strVal = String(val);
    fs.querySelectorAll('input[type="radio"]').forEach((r) => {
      r.checked = r.value === strVal;
    });
    const legendSpan = fs.querySelector('legend .form__label__value');
    if (legendSpan) legendSpan.textContent = strVal;
  });

  const hid = document.getElementById('selected-variant-id');
  if (hid) hid.value = best.id;

  vs.updateOptions();
  vs.updateMasterId();
  vs.updateVariantInput();
  vs.updateVariantText();
  vs.updatePickupAvailability();
  vs.removeErrorMessage();
  vs.updateButtonState();
  vs.setDisabledSync(false);

  const skuEl = document.querySelector('.product-sku span.sku-value');
  if (skuEl && best.sku) skuEl.textContent = best.sku;

  if (vs.dataset.updateUrl === 'true') {
    try {
      const u = new URL(window.location.href);
      u.searchParams.set('variant', best.id);
      window.history.replaceState({}, '', `${u.pathname}${u.search}${u.hash}`);
    } catch (_) {
      /* noop */
    }
  }

  void vs.updateMedia();
}

async function updateVariants() {
  // Get the variant-selects element to access getVariantData()
  const variantSelectsEl = document.querySelector('variant-selects');
  if (!variantSelectsEl) return;

  const variants = variantSelectsEl.getVariantData();
  const availableVariants = variants.filter(v => v.available);

  const container = document.querySelector('variant-selects .variations');
  if (!container) return;

  const fieldsets = container.querySelectorAll('fieldset.product-form__input');
  if (!fieldsets.length) return;

  const firstFieldset = fieldsets[0];
  const checkedRadio = firstFieldset.querySelector('input[type="radio"]:checked');

  if (checkedRadio) {
      const checkedValue = checkedRadio.value;
      const smallestAvailable = pickSmallestAvailableVariantForColor(
        availableVariants,
        checkedValue,
        fieldsets
      );

      if (smallestAvailable) {
          await updateVariantOptions(fieldsets, smallestAvailable, variants);
      }
  }
}

async function updateVariantOptions(fieldsets, firstAvailableVariant, availableVariants) {
  const { option2, option3, id } = firstAvailableVariant;

  if (fieldsets.length > 1) {
      updateFieldsetOptions(fieldsets[1], option2, availableVariants, 'option2');
  }
  if (fieldsets.length > 2) {
      updateFieldsetOptions(fieldsets[2], option3, availableVariants, 'option3');
  }

  const selectedVariant = document.getElementById('selected-variant-id');
  if (selectedVariant) selectedVariant.value = id;
  // SKU is set by replaceProductSections after updateMasterId() resolves
  // the correct current variant — do not set it here with firstAvailableVariant.sku.
}

function updateFieldsetOptions(fieldset, selectedOption, availableVariants, optionKey) {
  const radios = fieldset.querySelectorAll('input[type="radio"]');
  const selectedValue = fieldset.querySelector('legend.form__label span.form__label__value');

  radios.forEach(radio => {
    radio.checked = false;
    radio.classList.remove('is_selected');
  });

  radios.forEach(radio => {
    const matchingVariant = availableVariants.find(variant => variant[optionKey] === radio.value);
    
    if (matchingVariant) {
      radio.dataset.id = matchingVariant.id;
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', matchingVariant.id);
      radio.dataset.url = currentUrl.pathname + currentUrl.search;
    }

    if (radio.value === selectedOption) {
      radio.classList.add('is_selected');
      radio.checked = true;
      if (selectedValue) {
        selectedValue.textContent = radio.value;
      }
    }
  });
}

function initializeRadioButtons() {
  const radioButtons = document.querySelectorAll('variant-selects .variations fieldset.product-form__input:not([data-handle="color"]) input[type="radio"]');
  radioButtons.forEach((radio) => {
    if (radio.dataset.natoriVariantBound === '1') return;
    radio.dataset.natoriVariantBound = '1';
    radio.addEventListener('change', handleRadioChange);
  });
}

function handleRadioChange(event) {
  const selectedRadio = event.target;
  const selectedValue = selectedRadio.value;
  const fieldset = selectedRadio.closest('fieldset.product-form__input');
  const fieldsets = document.querySelectorAll('variant-selects .variations fieldset.product-form__input');
  const fieldsetIndex = Array.from(fieldsets).indexOf(fieldset) + 1;
  const secondFieldset = fieldsets[1];
  const thirdFieldset = fieldsets[2];

  let allVariants = [];
  let availableVariants = [];

  try {
    if (window.allVariants && Array.isArray(window.allVariants)) {
      allVariants = window.allVariants;
    } else {
      const scriptTag = document.querySelector('variant-selects script[type="application/json"]');
      if (!scriptTag) { console.error('Variant data not found'); return; }
      const jsonObject = JSON.parse(scriptTag.textContent.trim());
      if (!Array.isArray(jsonObject)) { console.error('Variant JSON is not an array'); return; }
      allVariants = jsonObject;
    }
    availableVariants = allVariants.filter(v => v.available);
  } catch (error) {
    console.error('Error reading variant data:', error);
    return;
  }

  const colorVal =
    document.querySelector('.product-form__input--color input[type="radio"]:checked')?.value ?? null;
  const sameColor = (v) => !colorVal || String(v.option1) === String(colorVal);

  const fieldsetsArr = Array.from(fieldsets);

  if (fieldsetIndex === 2 && secondFieldset) {
    const existingForBand = allVariants.filter((v) => v.option2 === selectedValue && sameColor(v));
    const availableForBand = existingForBand.filter((v) => v.available);
    if (thirdFieldset) {
      updateFieldsetRadios(thirdFieldset, existingForBand, availableForBand, 'option3');
      syncCupRadioVariantAttrs(thirdFieldset, allVariants, colorVal, selectedValue);
      const bandVal = selectedValue;
      const cupEl = thirdFieldset.querySelector('input[type="radio"]:checked');
      const cupVal = cupEl?.value;
      const comboExists =
        cupVal != null &&
        allVariants.some(
          (v) =>
            String(v.option1) === String(colorVal) &&
            String(v.option2) === String(bandVal) &&
            String(v.option3) === String(cupVal)
        );
      if (!comboExists) {
        const best = findSmallestExistingCupVariantForBand(
          allVariants,
          colorVal,
          bandVal,
          fieldsetsArr
        );
        if (best) {
          thirdFieldset.querySelectorAll('input[type="radio"]').forEach((r) => {
            r.checked = String(r.value) === String(best.option3);
          });
          const legendSpan = thirdFieldset.querySelector('legend .form__label__value');
          if (legendSpan) legendSpan.textContent = best.option3;
          syncCupRadioVariantAttrs(thirdFieldset, allVariants, colorVal, bandVal);
          const exb = allVariants.filter((v) => v.option2 === bandVal && sameColor(v));
          const avb = exb.filter((v) => v.available);
          updateFieldsetRadios(thirdFieldset, exb, avb, 'option3');
          syncCupRadioVariantAttrs(thirdFieldset, allVariants, colorVal, bandVal);
          dispatchVariantSelectsSyncFromCup(thirdFieldset);
        }
      }
    }
  } else if (fieldsetIndex === 3 && thirdFieldset) {
    const bandEl = secondFieldset?.querySelector('input[type="radio"]:checked');
    const bandVal = bandEl?.value;
    let cupValEffective = selectedValue;

    if (bandVal != null && colorVal) {
      const comboExists = allVariants.some(
        (v) =>
          String(v.option1) === String(colorVal) &&
          String(v.option2) === String(bandVal) &&
          String(v.option3) === String(selectedValue)
      );
      if (!comboExists) {
        const best = findSmallestExistingCupVariantForBand(
          allVariants,
          colorVal,
          bandVal,
          fieldsetsArr
        );
        if (best) {
          cupValEffective = best.option3;
          thirdFieldset.querySelectorAll('input[type="radio"]').forEach((r) => {
            r.checked = String(r.value) === String(best.option3);
          });
          const legendSpan = thirdFieldset.querySelector('legend .form__label__value');
          if (legendSpan) legendSpan.textContent = best.option3;
        }
      }
    }

    const existingForCup = allVariants.filter(
      (v) => v.option3 === cupValEffective && sameColor(v)
    );
    const availableForCup = existingForCup.filter((v) => v.available);
    if (secondFieldset) {
      updateFieldsetRadios(secondFieldset, existingForCup, availableForCup, 'option2');
    }
    if (thirdFieldset && bandVal != null && colorVal) {
      const exb = allVariants.filter((v) => v.option2 === bandVal && sameColor(v));
      const avb = exb.filter((v) => v.available);
      updateFieldsetRadios(thirdFieldset, exb, avb, 'option3');
      syncCupRadioVariantAttrs(thirdFieldset, allVariants, colorVal, bandVal);
    }
    if (String(cupValEffective) !== String(selectedValue)) {
      dispatchVariantSelectsSyncFromCup(thirdFieldset);
    }
  }
}

function updateFieldsetRadios(fieldset, existingVariants, availableVariants, optionKey) {
  const radiosInFieldset = fieldset.querySelectorAll('input[type="radio"]');
  const keepBandsVisible = fieldset.getAttribute('data-handle') === 'band';

  radiosInFieldset.forEach(radio => {
    const label    = fieldset.querySelector(`label[for="${radio.id}"]`);
    const exists   = existingVariants.some(v => v[optionKey] === radio.value);
    const available = availableVariants.some(v => v[optionKey] === radio.value);

    if (!exists) {
      if (keepBandsVisible) {
        radio.style.display = '';
        if (label) label.style.display = '';
        radio.classList.add('is-disabled');
        radio.checked = false;
      } else {
        radio.style.display = 'none';
        if (label) label.style.display = 'none';
        radio.classList.add('is-disabled');
        radio.checked = false;
      }
    } else if (!available) {
      // Exists but OOS — show with strikethrough/disabled style, preserve checked state
      radio.style.display = '';
      if (label) label.style.display = '';
      radio.classList.add('is-disabled');
    } else {
      // In stock — show normally
      radio.style.display = '';
      if (label) label.style.display = '';
      radio.classList.remove('is-disabled');
    }
  });

  // If the previously checked radio was hidden (non-existent), fall back to
  // first available, then first existing OOS option
  const nowChecked = Array.from(radiosInFieldset).find(r => r.checked);
  if (!nowChecked) {
    const firstAvailable = Array.from(radiosInFieldset).find(r => !r.classList.contains('is-disabled') && r.style.display !== 'none');
    const firstExisting  = Array.from(radiosInFieldset).find(r => r.style.display !== 'none');
    const toCheck = firstAvailable || firstExisting;
    if (toCheck) toCheck.checked = true;
  }
}

const _formatSizesOrder = new Map();

async function formatSizes() {
    const fieldsetSize = document.querySelector('fieldset.product-form__input[data-handle="size"]');
    const fieldsetBand = document.querySelector('fieldset.product-form__input[data-handle="band"]');
    const fieldsetCup  = document.querySelector('fieldset.product-form__input[data-handle="cup"]');

    function getOrStoreCanonicalOrder(fieldset) {
        const handle = fieldset.getAttribute('data-handle') || fieldset.getAttribute('data-index') || 'generic';
        if (!_formatSizesOrder.has(handle)) {
            const order = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
                .map(input => input.value);
            _formatSizesOrder.set(handle, order);
        }
        return _formatSizesOrder.get(handle);
    }

    function sortInputLabelPairs(pairs, orderArray = null, defaultSort = 'alphabetical') {
        pairs.sort((a, b) => {
            const aValue = a.input.value.toUpperCase();
            const bValue = b.input.value.toUpperCase();

            if (orderArray) {
                const aIndex = orderArray.indexOf(aValue);
                const bIndex = orderArray.indexOf(bValue);
                if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
                if (aIndex !== -1) return -1;
                if (bIndex !== -1) return 1;
            }

            const aNumeric = parseFloat(aValue);
            const bNumeric = parseFloat(bValue);
            if (!isNaN(aNumeric) && !isNaN(bNumeric)) return aNumeric - bNumeric;

            return defaultSort === 'alphabetical' ? aValue.localeCompare(bValue) : 0;
        });
    }

    function formatFieldset(fieldset, orderArray = null, defaultSort = 'alphabetical') {
        if (!fieldset) return;

        const canonicalOrder = getOrStoreCanonicalOrder(fieldset);
        const legend = fieldset.querySelector("legend.form__label");

        const inputLabelPairs = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map(input => {
            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            return { input, label };
        });

        if (orderArray) {
            sortInputLabelPairs(inputLabelPairs, orderArray, defaultSort);
        } else {
            inputLabelPairs.sort((a, b) => {
                const aIdx = canonicalOrder.indexOf(a.input.value);
                const bIdx = canonicalOrder.indexOf(b.input.value);
                if (aIdx === -1 && bIdx === -1) return 0;
                if (aIdx === -1) return 1;
                if (bIdx === -1) return -1;
                return aIdx - bIdx;
            });
        }

        inputLabelPairs.forEach(pair => {
            pair.input.remove();
            pair.label.remove();
        });
        for (let i = inputLabelPairs.length - 1; i >= 0; i--) {
            legend.insertAdjacentElement("afterend", inputLabelPairs[i].label);
            inputLabelPairs[i].label.insertAdjacentElement("beforebegin", inputLabelPairs[i].input);
        }
    }

    if (fieldsetSize) formatFieldset(fieldsetSize, NATORI_APPAREL_SIZES);
    if (fieldsetBand) formatFieldset(fieldsetBand, NATORI_BANDS, 'numeric');
    if (fieldsetCup)  formatFieldset(fieldsetCup, NATORI_CUPS, 'alphabetical');
    if (!fieldsetSize && !fieldsetBand && !fieldsetCup) {
        const genericFieldset = document.querySelector('fieldset.product-form__input');
        if (genericFieldset) {
            const hasNumericValues = Array.from(genericFieldset.querySelectorAll('input[type="radio"]'))
                .some(input => !isNaN(parseFloat(input.value)));
            formatFieldset(genericFieldset, null, hasNumericValues ? 'numeric' : 'alphabetical');
        }
    }
}

window.addEventListener('load', async() => {
  initializeRadioButtons();
  // await updateVariants();
  await formatSizes();
  applySmallestAvailableDefault();
  const variantOptionsEl = document.getElementById('variant-options');
  if (
    variantOptionsEl?.getAttribute('data-type') === 'Combined' &&
    !variantOptionsEl.classList.contains('loaded')
  ) {
    const obs = new MutationObserver(() => {
      if (variantOptionsEl.classList.contains('loaded')) {
        obs.disconnect();
        applySmallestAvailableDefault();
      }
    });
    obs.observe(variantOptionsEl, { attributes: true, attributeFilter: ['class'] });
  }
  if (!customElements.get("product-slider")) {
    //wait for all images to load before initializing the product slider
    const sliderInterval = setInterval(() => {
      const variantOptions = document.querySelector('#variant-options');
      if (variantOptions && variantOptions?.classList.contains('loaded')) {
        clearInterval(sliderInterval);
        initializeProductSlider();
      }
    }, 100);
  }
});